import React, { useState } from "react";
import styles from "./Tooltip.module.css";
import { cx } from "../../../Util/classHelpers";

const Tooltip = ({ 
  children, 
  content, 
  disabled = false,
  position = "top",
  className = ""
}) => {
  const [isVisible, setIsVisible] = useState(false);

  if (disabled || !content) {
    return children;
  }

  return (
    <div 
      className={cx(styles.tooltipContainer, className)}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className={cx(styles.tooltip, styles[position])}>
          <div className={styles.tooltipContent}>
            {content}
          </div>
          <div className={cx(styles.tooltipArrow, styles[`${position}Arrow`])} />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
